module.exports = __webpack_public_path__ + "static/media/wordpress-br.0f189c2a.png";